$('.cstm-radio-btn-label-wrapper').each(function(){
$(this).children('input').click(function(){
$(this).addClass('active');
$(this).parent().siblings().children('input').removeClass('active');
});
});



$(document).ready(function(){

  $(".cstm_variation_btn").click(function(){
if($(this).find("input").attr("disabled") != "disabled"){
var mai_var_id = $(this).find(".prc_span").attr("data-main_var_id");
$(".variation_data_wrapper .variation_data").each(function(){
  if($(this).attr("data-vari_id") == mai_var_id )
{
// var shortDescription = $(this).attr("data-shortDescription");
// var sizeTitle = $(this).attr("data-sizeTitle");
// var descriptionTag = $(this).attr("data-descriptionTag");
// var verticalDepth = $(this).attr("data-verticalDepth");
// var topoutDimension = $(this).attr("data-topoutDimension");
// var topinDimesnion = $(this).attr("data-topinDimesnion");

// var rimStyle = $(this).attr("data-rimStyle");
// var productReferFuide = $(this).attr("data-productReferFuide");
// var guage = $(this).attr("data-guage");
// var condition = $(this).attr("data-condition");
// var capacityFloz = $(this).attr("data-capacityFloz");
// var bottomDimensions = $(this).attr("data-bottomDimensions");
var var_sku = $(this).attr("data-variantsku");
var casePack = $(this).attr("data-casePack");
var caseCubeFt = $(this).attr("data-caseCubeFt");
var fulldecrtiption = $(this).attr("data-fulldecrtiption");
var shipWeightLbs = $(this).attr("data-shipWeightLbs");

// $(".short-description .std-para p").text(shortDescription);
$(".product-title").text(fulldecrtiption);
// $(".vertical_depth").find(".data.last").text(verticalDepth);
// $(".topoutDimension").find(".data.last").text(topoutDimension);
// $(".topindim").find(".data.last").text(topinDimesnion);
// $(".rim_style").find(".data.last").text(rimStyle);
// $(".prod_ref_guide").find(".data.last").html(productReferFuide);
// $(".gauge").find(".data.last").text(guage);
// $(".capacity_fl_oz").find(".data.last").text(capacityFloz);
// $(".bott_dimension").find(".data.last").text(bottomDimensions);
// $("#parentHorizontalTab .prod_tab.resp-tab-content").text(fulldecrtiption);
$(".cstm-grid-wrapper-product .sku-box p.itembox").html("<span>Item # : </span>" + var_sku);
$("#product-attribute-specs-table .item-box").find(".data.last").text(var_sku);
$(".ship_weightlb").find(".data.last").text(shipWeightLbs);
$(".casepack").find(".data.last").text(casePack);
$(".casecube").find(".data.last").text(caseCubeFt);
}  

});
}
});


//   function handleClick() {
//     if ($(this).find("input").attr("disabled") !== "disabled") {
//       var mai_var_id = $(this).find(".prc_span").attr("data-main_var_id");
//       $(".variation_data_wrapper .variation_data").each(function() {
//         if ($(this).attr("data-vari_id") === mai_var_id) {
//           var var_sku = $(this).attr("data-variantsku");
//           var casePack = $(this).attr("data-casePack");
//           var caseCubeFt = $(this).attr("data-caseCubeFt");
//           var fulldecrtiption = $(this).attr("data-fulldecrtiption");
//           var shipWeightLbs = $(this).attr("data-shipWeightLbs");

//           $(".product-title").text(fulldecrtiption);
//           $(".cstm-grid-wrapper-product .sku-box p.itembox").html("<span>Item # : </span>" + var_sku);
//           $("#product-attribute-specs-table .item-box").find(".data.last").text(var_sku);
//           $(".ship_weightlb").find(".data.last").text(shipWeightLbs);
//           $(".casepack").find(".data.last").text(casePack);
//           $(".casecube").find(".data.last").text(caseCubeFt);
//         }
//       });
//     }
//   }

//   $(".cstm_variation_btn").on("click", handleClick);

//   function handleLoad() {
//     // Your "on load" logic here
//     // ...

//     // Trigger the click event handler function
//     $(".cstm_variation_btn").trigger("click");
//   }

//   handleLoad();



// $(".cstm-product-variant-quantity-wrapper fieldset > .cstm-radio-btn-label-wrapper > input").each(function() {
//   var isChecked = $(this).is(":checked");
  
//   if (isChecked) {
//     $(this).addClass("check");
//     console.log("Checked attribute is set. Class added.");
//   } else {
//     console.log("Checked attribute is not set.");
//   }
// });
 $(".cstm-product-variant-quantity-wrapper fieldset>.cstm-radio-btn-label-wrapper>input:checked").trigger('click');


var string23 = $(".prod-title.ptg-1-1-2-lb-oblong-take-out-foil-pan-shallow-w-dome-lid-combo-500-cs a.pro-title.common-transition").text();
var string13 = $(".prod-title.ptg-1-1-2-lb-oblong-take-out-foil-pan-shallow-w-dome-lid-combo-500-cs span.PTG.Oblong").text();
var string1=string13.trim();
var string=string23.trim();
string = string.substring(0, string.length-6);
var new_text = string + string1+"/CS";
$(".prod-title.ptg-1-1-2-lb-oblong-take-out-foil-pan-shallow-w-dome-lid-combo-500-cs a.pro-title.common-transition").html(new_text);
console.log(new_text);
  

});



  
